// extracted by mini-css-extract-plugin
module.exports = {"btn-delete":"_3Bzfv85aKbhOJvHd7oNF14"};